<template>
  <v-container id="contact-list" class="contact-list" fluid tag="section" style="margin-top: -15px">
    <div class="md-layout">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <v-expansion-panels
        v-model="viewExpansionPanels"
        multiple
      >
        <v-expansion-panel>
          <v-expansion-panel-content class="panel-no-pb contact-filter">
            <v-row :style="isMobile ? 'height: 160px' : 'height: 50px'">
              <v-col cols="12" md="3" class="pb-0 pt-0">
                
                <div class="text-left mb-1 mt-2">
                  <v-btn min-width="45" small color="#AC0606" @click="createOrder()">
                    <v-icon dark>
                      mdi-plus
                    </v-icon>
                    Tạo đơn
                  </v-btn>
                </div>
                <div class="text-left mb-1 mt-2">
                  <v-menu offset-y v-if="false">
                    <template #activator="{ on: onMenu }">
                      <v-tooltip bottom>
                        <template #activator="{ on: onTooltip }">
                          <v-btn
                            min-width="45"
                            style="margin-right: 10px;"
                            class="mb-2"
                            color="info"
                            small
                            v-on="{ ...onMenu, ...onTooltip }"
                          >
                            <v-icon>mdi-gesture-tap</v-icon>
                          </v-btn>
                        </template>

                        <span>Thao tác</span>
                      </v-tooltip>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(action, index) in actionList"
                        :key="`${action.id}_${index}`"
                        @click="showModalAction(action.type, action.store)"
                      >
                        <v-list-item-title>
                          {{ action.title }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <template v-if="false">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          min-width="45"
                          v-on="on"
                          small
                          style="margin-right: 10px;"
                          color="primary"
                          dark
                          class="mb-2"
                          @click="clickAddContact"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Thêm mới</span>
                    </v-tooltip>
                  </template>

                  <v-tooltip bottom v-if="false">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        min-width="45"
                        v-on="on"
                        small
                        @click="chooseFile"
                        style="margin-right: 10px;"
                        color="success"
                        dark
                        class="mb-2"
                      >
                        <v-icon style="margin-right: 5px;">mdi-folder-upload</v-icon>
                      </v-btn>
                    </template>
                    <span>Upload</span>
                  </v-tooltip>

                  <v-menu
                    v-if="false"
                    :internal-activator="true"
                    v-model="filterForm.openRowMenu"
                    content-class="menu__customer--filter no-contain overflow-visible"
                    :close-on-content-click="false"
                    offset-y
                  >
                    <template #activator="{ on: onMenu }">
                      <v-tooltip bottom>
                        <template #activator="{ on: onTooltip }">
                          <v-btn
                            min-width="45"
                            small
                            class="mb-2"
                            dark
                            v-on="{ ...onMenu, ...onTooltip }"
                          >
                            <v-icon>mdi-view-column</v-icon>
                          </v-btn>
                        </template>

                        <span>Cột hiển thị</span>
                      </v-tooltip>
                    </template>
                    <card-row-attribute
                      :filterForm="filterForm"
                      :contactColumns="contactColumns"
                      :rowAttributes="rowAttributes"
                    />
                  </v-menu>

                  <v-tooltip bottom v-if="false">
                    <template #activator="{ on: onTooltip }">
                      <v-btn
                        min-width="45"
                        @click="showStatusTable()"
                        small
                        color="warning"
                        class="mb-2 ml-2"
                        dark
                        v-on="onTooltip"
                      >
                        <v-icon>mdi-format-align-middle</v-icon>
                      </v-btn>
                    </template>

                    <span>Ẩn/hiện mối quan hệ</span>
                  </v-tooltip>

                  <template v-if="false">
                    <v-menu offset-y>
                      <template #activator="{ on: onMenu }">
                        <v-tooltip bottom>
                          <template #activator="{ on: onTooltip }">
                            <v-btn
                              min-width="45"
                              class="ml-2 mb-2"
                              color="secondary"
                              dark
                              v-on="{ ...onMenu, ...onTooltip }"
                              small
                            >
                              <v-icon>mdi-format-align-bottom</v-icon>
                            </v-btn>
                          </template>

                          <span>Số dòng hiển thị</span>
                        </v-tooltip>
                      </template>
                      <v-list class="s-lines-displayed" style="min-width: 100px">
                        <v-list-item
                          class="lines-displayed pa-0"
                          style="cursor: pointer"
                          v-for="(item, index) in items"
                          :key="`${item.id}_${index}`"
                        >
                          <v-list-item-title
                            class="item-lines-displayed"
                            @click="changeLimit(item)"
                          >{{ item }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>

                  <v-tooltip bottom v-if="false">
                    <template #activator="{ on: onTooltip }">
                      <v-btn
                          min-width="45"
                          @click="showModule"
                          small
                          color="#096860"
                          class="mb-2 ml-2"
                          dark
                          v-on="onTooltip"
                      >
                        <v-icon>mdi-view-compact</v-icon>
                      </v-btn>
                    </template>

                    <span>Ẩn/hiện kho tổng</span>
                  </v-tooltip>
                </div>
              </v-col>
              <v-col cols="12" md="5" class="pb-0 pt-0"
                  :style="isMobile ? 'height: 35px' : ''">
                <filter-form
                  :filter-form="filterForm"
                  :mapListOptionsFilterForm="mapListOptionsFilterForm"
                  :distributionStatus="distributionStatus"
                  :studyHours="studyHours"
                />
              </v-col>
              <!-- <v-col cols="12" md="1"></v-col> -->
              <!-- <v-col cols="12" md="3" class="pb-0" v-if="totalItem > limit" style="display: flex; justify-content: flex-end"> -->

              <v-col :cols="isMobile ? 8 : 12" md="3" class="pb-0"
                  style="display: flex; justify-content: flex-end; padding: 0 12px">
                <div class="text-right mb-1 mt-2">
                  {{showContactsIndex()}}
                  <v-btn
                      small
                      class="pagination-btn-left"
                      @click="function() {currentPage--; pendingPage--}"
                      :disabled="currentPage == 1">
                    <v-icon>mdi-menu-left</v-icon>
                  </v-btn>
                  <v-btn
                      small
                      class="pagination-btn-right"
                      @click="function() {currentPage++; pendingPage++}">
                    <v-icon>mdi-menu-right</v-icon>
                  </v-btn>
                </div>
                <div style="width: 35px">
                  <v-text-field
                    class="pt-0 text-field-number"
                    v-model="pendingPage"
                    min="1"
                    step="1"
                    type="number"
                    @input="applyPendingPage()">
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
          <v-expansion-panel-content transition="fade" class="contact-status-table">
            <v-row>
              <v-col cols="12" class="pt-0 pb-0">
                <status-count-table
                  :filterForm="filterForm"
                  :totalContactStatus="totalContactStatus"
                  :typeHeaderContactStatus="typeHeaderContactStatus"
                  :contactStatusList="countContactStatusList"
                  :styleCountStatus="styleCountStatus"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
          <v-expansion-panel-content class="s-table-contact">
            <div>
              <contact-table
                :rowAttributes="rowAttributes"
                :filter-form="filterForm"
                :contacts="contacts"
                :currentPage="currentPage"
                :limit="parseInt(limit)"
                :mapStatusCode="mapStatusCode"
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
<!--    <modal-change-status-->
<!--      v-if="filterForm.modalType === 'status'"-->
<!--      :filter-form="filterForm"-->
<!--      :contacts="contacts"-->
<!--      :contactsSelected="contactsSelected"-->
<!--    />-->
  </v-container>
</template>

<script>
import FilterForm from './components/FilterForm';
import StatusCountTable from './components/StatusCountTable';
import ContactTable from './components/Table';
import { getContactAttribute, genFilterForm } from './config';
import RepositoryFactory from '@/repositories/RepositoryFactory'
const OrderRepository = RepositoryFactory.get('order')
import {
  contactStatus,
  typeContactExpand,
  contactStatusDefaultColor
} from '@/helpers/constants';
import { checkMobile } from '../../helpers/utils'
const ContactRepository = RepositoryFactory.get('contact');
const STATUS_TOKEN_EXPIRED = 402;
import CardRowAttribute from './components/CardRowAttribute';
import moment from 'moment'
import {SUBJECTS_SORT_CLASS} from '@/helpers/constants'
const today = moment(new Date(), "YYYY/MM/DD");
export default {
  components: {
    ContactTable,
    StatusCountTable,
    FilterForm,
    CardRowAttribute,
  },
  data() {
    return {
      errorMessage: '',
      items: [10, 20, 50, 100, 200, 500],
      mapListOptionsFilterForm: {},
      filterForm: {
        closeMenu: false,
      },
      currentPage: 1,
      pendingPage: 1,
      limit: 50,
      contacts: [],
      loading: true,
      viewExpansionPanels: [0, 1],
      panel: [0, 1],
      typeHeaderContactStatus: [],
      countContactStatusList: [],
      totalContactStatus: 0,
      distributionStatus: [],
      studyHours: [],
      showStatus: true,
      contactColumns: {},
      rowAttributes: getContactAttribute(),
      isMobile: false,
      productList: [],
      listStudyResult: {
        CHAMCHI: 'Chăm chỉ',
        BINHTHUONG: 'Bình thường',
        LUOIHOC: 'Bình thường',
        KHONGHOC: 'Không học',
        PHUCTAP: 'Phức tạp'
      },
      provinceList: [],
      contactsSelected: [],
      typeHeaderContactModule: [],
      countContactModuleList: [],
      totalContactModule: 0,
      showModuleTable: true,
      isShowModule: false,
      mapContactStatusIdCanCall: {},
      styleCountStatus: 2,
      statusId: [],
      mapStatusCode: {},
    };
  },
  computed: {
    actionList() {
      const actionList = [];
      actionList.push({ title: 'Chuyển mối quan hệ', type: 'status', store: 'all' });

      return actionList;
    },
    statusContactViewAll() {
      return this.checkAuthorization('contact_view_all');
    }
  },
  async created() {
    const { filterForm, mapListOptionsFilterForm, mapKeyAndIsMultiple, mapKeyAndDataType} = genFilterForm();
    this.mapListOptionsFilterForm = mapListOptionsFilterForm;
    if (_.isEmpty(this.$route.query)) {
      this.filterForm = filterForm;
    }
    let qp = new URLSearchParams(window.location.search);
    if (!_.isEmpty(this.$route.query)) {
      for (let key in this.$route.query) {
        let value = qp.get(key) === "false" ? false :
            qp.get(key) === "null" ? null :
                qp.get(key) === 'undefined' ? null :  qp.get(key);
        if(mapKeyAndIsMultiple[key]){
          if (value){
            this.filterForm[key] = value?.split(',')
            if (mapKeyAndDataType[key] === 'number' && this.filterForm[key] && this.filterForm[key].length > 0) {
              this.filterForm[key] = this.filterForm[key].map((e)=>{
                return parseInt(e)
              })
            }
          }else if (!value){
            this.filterForm[key] = null
          }
        }else if (!mapKeyAndIsMultiple[key]){
          if (mapKeyAndDataType === 'number') value = parseInt(value)
          this.filterForm[key] = value
        }
      }
    }

    if (!this.filterForm.timeRange){
      this.filterForm.timeRange = []
    }

    if (this.$route?.query?.page){
      this.pendingPage = parseInt(this.$route?.query?.page);
      this.currentPage = parseInt(this.$route?.query?.page);
    }

    if (this.filterForm.store == 'G') {
      if (!this.checkAuthorization('check_store_g_read')) {
        this.filterForm.store = 'T'
        window.history.pushState({store: 'T'}, "",
          window.location.origin + "/contact/contact-list?store=T")
      }
    }

    if((!this.$store.state.module.typeId && !this.$store.state.module.schoolLevelId)) {
      this.showStatus = false
      this.showModuleTable = true
      this.isShowModule = true
    }
    this.loading = this.$loading.show();
    await this.getCountStatusList();
    this.loading.hide();
    if (!this.$route?.query?.page || this.$route?.query?.page == 1){
      this.getList();
    }

    this.getFilterFormOptions();
    this.mapListOptionsFilterForm['subjects'] = SUBJECTS_SORT_CLASS;
    let check = checkMobile()
    if (check) {
      this.isMobile = true
    }
    setTimeout(() => {
      Bus.$on('contact-list-filter', filterForm => {
        this.filterForm = filterForm
        this.filterForm.closeMenu = false;
        if(this.currentPage != 1){
          this.currentPage = 1;
          this.pendingPage = 1;
        }else if(this.currentPage == 1) {
          this.getList();
        }
        this.getCountStatusList();
      });
      Bus.$on('contact-list-filter-by-contact-status', filterForm => {
        this.filterForm = filterForm;
        this.filterForm.closeMenu = false;
        if(this.currentPage != 1){
          this.currentPage = 1;
          this.pendingPage = 1;
        }else if(this.currentPage == 1) {
          this.getList();
        }
      });
      Bus.$on('contact-status-list', (statusId) => {
        this.filterForm.orderStatusId = statusId;
        this.getList();
        this.getCountStatusList();
      });
      Bus.$on('product-group-list', () => {
        this.getList()
      });
      Bus.$on('contact-change-row-attribute', cloneRowAttributes => {
        this.rowAttributes = cloneRowAttributes.map(s => ({ ...s }));
      });
    }, 0)
  },
  async updated() {
    setTimeout(() => {
      this.getStyleTable();
    }, 300);
  },
  beforeDestroy() {
    Bus.$off('contact-list-filter');
    Bus.$off('contact-status-list');
    Bus.$off('contact-change-row-attribute');
    Bus.$off('product-group-list');
    Bus.$off('contact-list-filter-by-contact-status');
  },
  methods: {
    getStyleTable() {
      let heightFilter = document.querySelector('.contact-filter')
        ? document.querySelector('.contact-filter').clientHeight
        : 0;
      let heightReport = document.querySelector('.report-achievement')
        ? document.querySelector('.report-achievement').clientHeight
        : 0;
      let heightStatus = document.querySelector('.contact-status-table')
        ? document.querySelector('.contact-status-table').clientHeight
        : 0;
      let totalHeader =
        heightFilter + heightReport + heightStatus + 45 + 'px';
      let heightTable = document.querySelector('.contact-table');
      if(heightTable) {
        if (this.contacts.length === 0) {
          heightTable.style.height = `auto`;
        } else {
          heightTable.style.height = `calc(100vh - ${totalHeader})`;
        }
      }
    },

    chooseFile() {
      this.$refs.contactFileInput.click();
    },
    async changeLimit(limit) {
      this.limit = limit;
    },
    showStatusTable() {
      this.showStatus = !this.showStatus;
      if(this.isShowModule && this.showModuleTable) {
        this.showModuleTable = false
      }
      if(this.showStatus && _.isEmpty(this.typeHeaderContactStatus)) {
        //this.getCountStatusList();
      }
    },
    showModalAction(modalType, store = 'all') {
      const changeContactList = this.contacts.filter(
        contact => contact.checkbox
      );
      this.contactsSelected = _.cloneDeep(changeContactList)
      const checkContactList = []
      changeContactList.forEach(contact => {
        if (contact.contactType == 'sub') {
          checkContactList.push(contact.mobile)
        }
      })
      if (checkContactList.length > 0) {
        return this.$swal({
          title: 'Lỗi !',
          text: 'Contact ' + checkContactList.join(", ") + " là contact phụ."
        })
      }
      if (changeContactList.length === 0) {
        return this.$swal({
          title: 'Lỗi !',
          text: 'Vui lòng chọn khách hàng !!!'
        });
      }

      if (modalType === 'user' && changeContactList.length > 5) {
        return this.$swal({
          title: 'Nếu bạn muốn thu hồi contact, hãy thực hiện thao tác thu hồi trước!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          closeOnConfirm: false,
          cancelButtonText: 'Không'
        }).then(async result => {
          if (!result.value) {
            return this.filterForm.modalType = modalType;
          }
        });
      }

      // Check contact cùng module
      if (modalType === 'status') {
        for(let j  = 1; j < changeContactList.length; j++) {
          if (changeContactList[j].typeId !== changeContactList[0].typeId
              || changeContactList[j].schoolLevelId !== changeContactList[0].schoolLevelId) {
            return this.$swal({
              title: 'Lỗi !',
              text: 'Vui lòng chọn các contact có cùng Module !!!'
            });
          }
        }
      }


      this.filterForm.modalType = modalType;
    },
    clickAddContact() {
      alert('add-contact');
    },
    async getCountStatusList() {
      const params = {
        keyword: this.filterForm.keyword?.trim(),
        groupIds: this.filterForm.orderProvider,
      };
      if(this.filterForm.paymentProvider){
        params.paymentName = this.filterForm.paymentProvider
      }
      if(this.filterForm.paymentTypeId){
        params.paymentType = this.filterForm.paymentTypeId
      }
      if(this.filterForm.timeRange && this.filterForm.timeRange.length > 1){
        params.startDate = `${moment(this.filterForm.timeRange[0]).format('DD/MM/YYYY')}`
        params.endDate = `${moment(this.filterForm.timeRange[1]).format('DD/MM/YYYY')}`
      }
      const response = await OrderRepository.getCountStatusListOrder(params)
      if(this.styleCountStatus === 1){
        this.totalContactStatus = 0;
        if (response.success) {
          const typeHeaderContactStatus = [];
          const contactStatusList = [];
          const typeExpand = typeContactExpand;
          let statusFirstTypeExpand = false;
          let notInTypeList = [];
          if (!this.isManager()) {
            notInTypeList = ['T0', 'C0', 'G0'];
          }
          for (let contactStatus of _.get(response, 'data', [])) {
            if (notInTypeList.includes(contactStatus.type)) {
              continue;
            }
            typeHeaderContactStatus.push({
              name: !this.$store.state.module.typeId ? contactStatus.type : contactStatus.type.slice(-2),
              colspan: _.get(contactStatus, 'data', []).length || 1
            });
            _.get(contactStatus, 'data', []).forEach(data => {
              contactStatusList.push({
                type: contactStatus.type,
                id: _.get(data, 'id', 0),
                color:
                    _.get(data, 'color', contactStatusDefaultColor) ||
                    contactStatusDefaultColor,
                noContact: _.get(data, 'noContact', 0),
                name: _.get(data, 'name', 0),
                statusFirstTypeExpand:
                    typeExpand.includes(contactStatus.type) &&
                    !statusFirstTypeExpand
              });
              if (
                  typeExpand.includes(contactStatus.type) &&
                  !statusFirstTypeExpand
              ) {
                statusFirstTypeExpand = true;
              }

              this.totalContactStatus += parseInt(_.get(data, 'noContact', 0));
              if (data && data.type && data.type.slice(-2) === 'T1'){
                if (data.code === 'NEW' || data.code === "KNM"){
                  this.mapContactStatusIdCanCall[data.id]= true
                }
              }
              if (data && data.type && data.type.slice(-2) === 'T2' && data.code === "HGGL"){
                this.mapContactStatusIdCanCall[data.id]= true
              }
              if (data && data.type && data.type.slice(-2) === 'T0' && data.code === "TESTDIAL"){
                this.mapContactStatusIdCanCall[data.id]= true
              }
            });
          }
          this.typeHeaderContactStatus = typeHeaderContactStatus;
          this.countContactStatusList = contactStatusList;
        } else {
          const statusCode = _.get(response, 'data.code', 200);
          this.typeHeaderContactStatus = [];
          this.countContactStatusList = [];
          this.totalContactStatus = 0;
        }
      }
      if(this.styleCountStatus === 2){
        const countStatusModuleList = [];
        let totalContact = 0;
        if (response.success && !response.data.length) {
          countStatusModuleList.push({
            type: item.name, id: 0, noContact: '', name: '', typeId: item.id, color: '#ffffff',
          });
        }
        response.data?.forEach((item) => {
          if (item.code !== 'all') {
            this.mapStatusCode[item.id] = { color: item.color ,name: item.name };
            totalContact += parseInt(item.no, 10);
            const bodyObject = {
              id: item.id, noContact: item.no, name: item.name, color: item.color,
            };
            countStatusModuleList.push(bodyObject);
          }
        });
        this.countContactStatusList = countStatusModuleList;
        this.totalContactStatus = totalContact;
      }
    },
    async getFilterFormOptions(){
      const response = await OrderRepository.getFilterFormOptions()
      if (response.success){
        this.mapListOptionsFilterForm['paymentProviders']  = _.get(response, 'data.paymentNameOptions', []);
        this.mapListOptionsFilterForm['orderStatuses'] = _.get(response, 'data.statusOptions', []);
        this.mapListOptionsFilterForm['paymentTypes'] = _.get(response, 'data.paymentTypeOptions', []);
      }
      const res = await OrderRepository.getGroupProduct();
      if (res.success){
        this.mapListOptionsFilterForm['orderProviders'] = _.get(res, 'data', []);
      }

    },
    async getList() {
      let filterForm = _.cloneDeep(this.filterForm)
      const params = {
        limit: this.limit,
        keyword: this.filterForm.keyword?.trim(),
        page: this.currentPage,
        groupIds: this.filterForm.orderProvider,
      };
      if(this.filterForm.paymentProvider){
        params.paymentName = this.filterForm.paymentProvider
      }
      if(this.filterForm.orderStatusId){
        params.status = this.filterForm.orderStatusId
      }
      if(this.filterForm.paymentTypeId){
        params.paymentType = this.filterForm.paymentTypeId
      }
      if(this.filterForm.timeRange && this.filterForm.timeRange.length > 1){
        params.startDate = `${moment(this.filterForm.timeRange[0]).format('DD/MM/YYYY')}`
        params.endDate = `${moment(this.filterForm.timeRange[1]).format('DD/MM/YYYY')}`
      }

      this.filterForm.modalType = '';
      this.filterForm.checkboxAll = false;
      this.loading = this.$loading.show();
      const response = await OrderRepository.getListOrder(params)
      this.loading.hide();
      if (_.get(response, 'success', false)) {
        let data = _.get(response, 'data', []);
        if(data?.length > 0){
          data.forEach(record =>{
            record.checkbox = false;
            record.createdAt = moment(record.createdAt).format("HH:mm:ss DD/MM/YYYY");
          })
        }
        this.contacts = data
      } else {
        this.contacts = [];
        const statusCode = _.get(response, 'data.code', STATUS_TOKEN_EXPIRED);
      }
    },
    applyPendingPage: _.debounce(function() {
        this.currentPage = parseInt(this.pendingPage)
        return
    }, 500),

    showContactsIndex() {
      if(this.contacts.length > 0) {
        let maxIndex = parseInt(this.currentPage)*parseInt(this.limit)
        return (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
      }else {
        return ('0 - 0')
      }
    },
    showModule() {
      this.showModuleTable = !this.showModuleTable;
      if(this.showStatus) {
        this.showStatus = false;
      }
    },
    addHashToLocation(params) {
      if(!params?.keyword){
        params.keyword = '';
      }
      let qp = new URLSearchParams();
      for (let k in params) {
        if (params.hasOwnProperty(k)) {
          qp.set(k,params[k])
        }
      }
      history.replaceState(
          {},
          null,
          this.$route.path + '?' + qp.toString()
      )
    },

    // Chuyển đến màn "tạo đơn hàng"
    createOrder() {
      this.$router.push({
        name: "CreateOrder"
      })
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.addHashToLocation( {...this.filterForm, page: this.currentPage });
        this.getList();
      }
    },
    filterForm: {
      handler(val) {
        if(val?.keyword?.length > 30){
          this.$swal({
            title: 'Ký tự tìm kiếm không được vượt quá 30 ký tự',
          })
        }
        this.addHashToLocation({...this.$route.query, ...this.filterForm});
      },
      deep: true,
    },
    limit: {
      handler() {
        if (this.currentPage === 1) {
          this.getList();
        } else {
          this.currentPage = 1;
          this.pendingPage = 1;
        }
      }
    }
  }
};
</script>
<style scoped>
#contact-list {
  padding-bottom: 0px;
}
::v-deep.v-expansion-panel::before {
  box-shadow: none;
}
::v-deep.c-pagination .v-pagination__navigation {
  height: 28px;
  width: 28px;
}
::v-deep.c-pagination .v-pagination__item {
  height: 28px;
  min-width: 28px;
  font-size: 12px;
}
.lines-displayed {
  min-height: auto;
}
.lines-displayed .item-lines-displayed {
  width: 100%;
  padding: 8px 15px;
  margin: 4px 0px;
  cursor: pointer;
}
.lines-displayed .item-lines-displayed:hover {
  background: #d2d2d2;
}
::v-deep.filter-store input {
  font-size: 13px !important;
}
::v-deep.report-achievement .v-expansion-panel-content__wrap {
  padding: 0;
}

.pagination-btn-left, .pagination-btn-right {
  max-width: 30px !important;
  min-width: 30px !important;
  background-color: #ffffff !important;
}
.pagination-btn-left i, .pagination-btn-right i {
  color: rgba(0,0,0,.54) !important
}
.pagination-btn-left {
  margin: 0px 5px 2px 10px !important;
}
.pagination-btn-right {
  margin: 0px 10px 2px 5px !important;
}
::v-deep.panel-no-pb .v-expansion-panel-content__wrap {
  padding-bottom: 0px;
}
::v-deep.v-expansion-panel-content .v-expansion-panel-content__wrap {
  padding-left: 15px;
  padding-right: 15px;
}
::v-deep.s-table-contact.v-expansion-panel-content .v-expansion-panel-content__wrap {
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 0px;
}
</style>
